import { MarketPriceConfigResponse } from 'api/v1/market'
import { TradeType } from 'store/market/types'
import { OrderDirection } from 'store/spot/types'
import { Ether } from 'types'
import { e2w, toFixed, w2e } from './number'

export function calculateMarketPriceForStopMarket(
  direction: OrderDirection,
  stopPrice: Ether,
  tradeType: TradeType,
  quoteScale: number,
  marketPriceConfig: MarketPriceConfigResponse | undefined,
): Ether {
  if (!marketPriceConfig) {
    return '0'
  }
  const changeLimit =
    tradeType === TradeType.Spot
      ? marketPriceConfig.SPOTS_CHANGE_LIMIT
      : marketPriceConfig.CONTRACTS_CHANGE_LIMIT
  const signPercent =
    tradeType === TradeType.Spot
      ? marketPriceConfig.SPOTS_SIGN_PERCENT
      : marketPriceConfig.CONTRACTS_SIGN_PERCENT

  const cl = e2w(changeLimit)
  const sp = e2w(signPercent)
  const p = e2w(stopPrice)

  let reduction = p.mul(cl).div(e2w(1))
  reduction = reduction.mul(sp).div(e2w(1))

  const adjustedPrice =
    direction === OrderDirection.LONG ? p.add(reduction) : p.sub(reduction)

  return toFixed(w2e(adjustedPrice), quoteScale)
}
